import { RootStoreProps } from '@platform/front-core';
import { RootStore as RootStoreInj } from '@platform/ics-front-core';
import { injectable } from 'react-magnetic-di';
import { apiConfigs } from '../../apiConfigs';
import { PortalLinksDTO } from '../../types';
import { PermissionsStore } from './PermissionsStore';

export class RootStore extends RootStoreInj {
    constructor(props: RootStoreProps) {
        super(props);
        this.coreRootStore.permissionsStore = new PermissionsStore();
        this.getHeaderLinks().then((links) => {
            const { portalUrl, portalLkUrl } = links;
            this.coreRootStore.headerLinksStore.setLogoLink({ isToOuterResource: true, url: portalUrl });
            this.coreRootStore.headerLinksStore.setProfileCustomLink({ isToOuterResource: true, url: portalLkUrl });
        });
    }

    async getHeaderLinks(): Promise<PortalLinksDTO> {
        return this.coreRootStore.api.mainInfoClient(apiConfigs.getHeaderLinks).then((r) => r.data);
    }
}

export const RootStoreDI = injectable(RootStoreInj, RootStore);
